import React, { useMemo } from 'react'
import { TextArea, TextAreaProps } from 'components/TextArea'
import { FieldValues, UseFormGetValues, UseFormSetValue } from 'react-hook-form'


export interface NumberOrBulletTextAreaProps extends TextAreaProps {
  onChangeHelper?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  isDotOrNumber: 'dot' | 'number'
  textAreaStyle: string
  setValue: UseFormSetValue<FieldValues>
  getValues: UseFormGetValues<FieldValues>,
}

export default function NumberOrBulletTextArea({
  setValue,
  getValues,
  textAreaStyle,
  isDotOrNumber,
  label,
  register,
  name,
  inputWidth,
  error,
  required,
  container,
  subLabel,
  inputLength,
  rows,
  noBorder,
  maxLength,
  onChangeHelper,
  ...rest }: NumberOrBulletTextAreaProps) {
  const placeHolder = useMemo(() => {
    return isDotOrNumber === 'dot' ? '• ' : '1. '
  }, [isDotOrNumber])
  
  const handlerKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    let name = event.currentTarget.name
    const text: string = getValues(name)
    //number and dot at the end
    const regex = isDotOrNumber === 'dot' ? /•\s$/ : /\d+\.\s$/;
    if (event.key === 'Backspace' && regex.test(text) && text.length < maxLength) {
      event.preventDefault();
      const lines = text.split('\n');
      lines.pop()
      
      if (lines.length === 0) {
        lines.push(placeHolder)
      } 

      setValue(name, lines.join("\n"))

    } else if (event.key === 'Enter' && text.length <= maxLength) {
      event.preventDefault();
      const doesEnd = text.endsWith('\n') || text.length === 0
      const newLine = doesEnd ? '' : '\n'

      let textFormat = (text + newLine).trim().concat('\n');
      if(textFormat.length <= maxLength){       
        setValue(name, textFormat)
      } 
    }
  };

  const handleTextEditableListChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    let name = event.currentTarget.name
    const textValue = event.target.value;
    const lines = textValue.split('\n');
    const filteredLines = lines.filter(text => text !== '')
   
    
    let totalNumberOfLetters = 0;
    const data = filteredLines.map((line, idx) => {
      const regex = isDotOrNumber === 'dot' ? /•\s/ : /\d+\.\s/;
      const cleanLine = line.split(regex)
      const place = isDotOrNumber === 'dot' ? '• ' : `${idx + 1}. `
      const data = `${place}${cleanLine.join('')}`;
      totalNumberOfLetters += data.length
      return data;
    })
    if (totalNumberOfLetters <= maxLength) {
      setValue(name, data.join("\n"))
    }
    if (onChangeHelper) {
      onChangeHelper(event)
    }
  }

  return (
    <TextArea
      data-testId="test-number-or-dot-element"
      error={error}
      required={required}
      onKeyDown={(e) => handlerKeyDown(e)}
      onChange={(e) => { handleTextEditableListChange(e) }}
      name={name}
      register={register}
      className={textAreaStyle}
      placeholder={placeHolder}
      rows={8}
      container={container}
      maxLength={maxLength}
      inputLength={inputLength}
      {...rest}
    />
  )
}
